module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/13.7fb72bf5.png";